import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=f74a6046&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f74a6046')) {
      api.createRecord('f74a6046', component.options)
    } else {
      api.reload('f74a6046', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=f74a6046&", function () {
      api.rerender('f74a6046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wYZKiNAwh7we/JS/cancellationPolicy.vue"
export default component.exports